import React, { Component } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { connect } from "react-redux";
import Select from "react-select";
import withFetchHook from "../withFetchHook";

class PasswordResetFormModal extends Component {
  constructor(props) {
    super(props);
    var lastUser = props.users[props.users.length - 1]
    let selectedUser = {
      value: lastUser.id,
      label: `${lastUser.first_name} ${lastUser.last_name} [${lastUser.email}]`
    }
    this.state= {
      selectedUser,
      password: '',
    }
  }

  handleClose() {
    this.props.closeModal();
  }

  handlePasswordChange(e){
    const password = e.target.value
    this.setState(()=>({ password }))
  }

  handleSubmit() {
    const { selectedUser, password } = this.state;
    const { organizationName, passwordResetSuccess, passwordResetFailed } = this.props;
    this.props.fetch(`/organizations/${organizationName}/users/${selectedUser.value}/reset_password.json`, {
      method: "PATCH",
      data: {
        user: {
          password
        }
      }
    }).then((data) => {
      if (data.error){
        passwordResetFailed(data.error)
      } else {
        passwordResetSuccess()
      }
      this.handleClose()
    })
  }

  submitButtonEnabled(){

    return ((this.state.password.length > 5) && this.state.selectedUser != null)
  }

  render() {
    const { users } = this.props;
    const userOptions = users.map(user => ({
      value: user.id,
      label: `${user.first_name} ${user.last_name} [${user.email}]`
    }))
    const { password, selectedUser } = this.state
    return (
      <Modal show={this.props.show} onHide={this.handleClose.bind(this)}>
        <Modal.Header closeButton>
          <Modal.Title>Change Password</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <Form.Group controlId="occupancyGroupId">
              <Form.Label>User Email:</Form.Label>
              {
                users.length > 1 ?
                <Select
                  placeholder="Select User..."
                  isClearable
                  value={selectedUser}
                  options={userOptions}
                  inputProps={{ autoComplete: 'new-password' }}
                  onChange={(option) => { this.setState(()=>({selectedUser: option}))} } /> :
                <div>
                  <b>{`${users[0].first_name} ${users[0].last_name} [${users[0].email}]`}</b>
                </div>
              }
              <Form.Label className="text-danger">{ selectedUser == null && 'User must be selected.' }</Form.Label>
            </Form.Group>
            <Form.Group controlId={`password_reset`}>
              <Form.Label>Enter New Password</Form.Label>
              <Form.Control
                autoComplete="new-password"
                type="password"
                value={password}
                onChange={this.handlePasswordChange.bind(this)}/>
              <Form.Label className="text-danger"> { (0 < password.length && password.length < 6) && 'Password must be atleast 6 characters long.'}</Form.Label>
              <Form.Label>This password will not be sent to the client. Please provide the client with the password you typed above.</Form.Label>
            </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button
            disabled={ !this.submitButtonEnabled() }
            variant="info"
            onClick={() => this.handleSubmit()}>
            Change Password
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    show: state.ui.passwordResetModal.show,
    users: state.users,
    residentId: state.resident.id,
    organizationName: state.organization.name,
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    closeModal: () => dispatch({ type: "CLOSE_RESOURCE_MODAL", payload: { resourceName: "passwordReset" }}),
    passwordResetSuccess: () => dispatch({ type: "PASSWORD_RESET_SUCCESS" }),
    passwordResetFailed: (error) => dispatch({ type: "PASSWORD_RESET_FAILED", payload: { error } }),
  };
}

export default withFetchHook(connect(mapStateToProps, mapDispatchToProps)(PasswordResetFormModal));
